import React, {useEffect, Fragment} from 'react'
//import Meta from '../../../component/ui/Meta';
import NotFoundImg from '../../../assets/img/404.svg';
import {useHistory, useLocation, Redirect} from 'react-router-dom';
import { currentLang } from '../../../utils/functions';
//import Meta from '../../../components/ui/Meta';
import Meta from '../../../components/ui/Meta';
import { useTranslation } from 'react-i18next';
import W from '../../../components/ui/Word';

const NotFound = () => {
    //const history = useHistory();
    const {pathname} = useLocation();
    const { t } = useTranslation();   

    useEffect(() => {
        
        //history.push("/"+currentLang()+"/404");
    }, [pathname])
    return (
        <Fragment>
        {pathname.substring(4, 7) != "404" &&
            <meta http-equiv="refresh" content={"0;url=/"+currentLang()+"/404"} />
        }
        <Meta
            title={t("404")}
            description=""
        />
        <div className="container">
            <div className="row">
                <div className="col page404">
                    
                    <div className="img mb-20">
                        <img alt="Page not found" src={NotFoundImg} />
                    </div>
                    <h2 className="heading--h2">
                        <W>Notfound.title</W>
                    </h2>
                    <p><W>Notfound.subtitle</W></p>
                    <a href="/" className="btn btn--red btn--outline mt-20"><i className="icon-arrow-left mr-10"></i> <W>Notfound.button</W> </a>
                </div>
            </div>
        </div>
        </Fragment>
    )
}

export default NotFound
